import { useMatchMedia } from '@hooks/use-match-media'
import { useTrackOpenDialog } from '@hooks/use-track-open-dialog'
import RichText from '@resolvers/rich-text'
import { defaultRichTextFieldOptionsDeprecated } from '@resolvers/rich-text/default-rich-text-field-options-deprecated'
import { type RichTextType } from '@resolvers/rich-text/types'
import { type ModalProps } from '@ui/atoms/modal'
import { ModalUI } from '@ui/modal/modal'
import { device } from '@utils/breakpoints'
import React, { type FC, useEffect } from 'react'

const LegalMentionsDialog: FC<ModalProps & { legalMentions: RichTextType }> = ({
  legalMentions,
  visible,
  onClose,
  ...modalProps
}) => {
  const isLaptopUp = useMatchMedia(device.laptop)
  const trackOpenDialog = useTrackOpenDialog('voir_conditions')

  useEffect(() => {
    if (visible) {
      trackOpenDialog()
    }
  }, [visible])

  return (
    <ModalUI
      fullScreen={!isLaptopUp}
      modalTitle={<h3 className="text-135">Conditions</h3>}
      visible={visible}
      buttons={[
        {
          onClick: onClose,
          children: "J'ai compris",
        },
      ]}
      onClose={onClose}
      {...modalProps}
    >
      <div className="text-text-default">
        <RichText
          content={legalMentions}
          options={defaultRichTextFieldOptionsDeprecated}
        />
      </div>
    </ModalUI>
  )
}

export default LegalMentionsDialog
